var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiologie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 896",
    d: "M32.897 31.1c-1.278-9.8-1.99-19.043 6.015-27.05A2.372 2.372 0 0 0 35.557.7c-9.224 9.224-8.8 19.585-7.525 29.772q1.534.192 3.063.4c.602.073 1.202.151 1.802.228Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 897",
    d: "M29.107 30.899c1.276 9.8 1.988 19.041-6.017 27.051a2.373 2.373 0 1 0 3.353 3.358c9.224-9.227 8.795-19.587 7.523-29.77q-1.53-.192-3.056-.4c-.602-.08-1.205-.161-1.803-.239Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 898",
    d: "M61.351 22.867a2.109 2.109 0 0 0-3.131 0c-7.475 8-16.1 7.293-25.247 6.019l-1.681-.237-2.859-.4c-9.5-1.272-19.173-1.7-27.785 7.525a2.491 2.491 0 0 0 0 3.355 2.11 2.11 0 0 0 3.131 0c7.471-8.007 16.1-7.3 25.247-6.017.56.078 1.12.159 1.685.24l2.852.4c9.5 1.269 19.173 1.7 27.787-7.525a2.5 2.5 0 0 0 .001-3.36Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 899",
    d: "M24.806 44.372a2.372 2.372 0 0 0 1.677-4.05l-4.8-4.8a2.372 2.372 0 0 0-3.355 3.355l4.8 4.8a2.356 2.356 0 0 0 1.678.695Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 900",
    d: "M10.148 39.66a2.372 2.372 0 0 0-3.355 3.355L18.988 55.21a2.372 2.372 0 1 0 3.355-3.355Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 901",
    d: "M51.855 22.343a2.372 2.372 0 1 0 3.355-3.355L43.015 6.793a2.372 2.372 0 0 0-3.355 3.355Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 902",
    d: "M35.517 18.324a2.37 2.37 0 0 0 0 3.355l4.8 4.8a2.372 2.372 0 0 0 3.355-3.355l-4.8-4.8a2.37 2.37 0 0 0-3.355 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiologie);
export default __webpack_public_path__ + "static/media/biologie.56f9e78e5088b5292b6848e1d3cc6a85.svg";
export { ForwardRef as ReactComponent };